import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from './Home'
import About from './About'
import Contact from './Contact'
import Products from './Products'
import Downloads from './Downloads'
import ProductDetails from './ProductDetails'

const Routers = () => {
  return (
   
    <Routes>
        <Route  path="/"  Component={Home} />
        <Route  path="/about"  Component={About} />
        <Route path='/products' Component={Products} />
        <Route path='/products/:id' Component={ProductDetails} />
        <Route path='/downloads' Component={Downloads} />
        <Route path="/contact" Component={Contact} />
    </Routes>
    
  )
}

export default Routers